import { ButtonHTMLAttributes } from 'react';

import clsx from 'clsx';

import { Button } from '../ui/button';

type OptionButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> & {
  value: string;
  active?: boolean;
  onClick?: (value: string) => void;
  variant?: 'outline-muted' | 'ghost' | 'ghost-secondary';
};

export function OptionButton(props: OptionButtonProps) {
  const {
    active,
    onClick,
    value,
    children,
    className = '',
    variant = 'outline-muted',
    disabled,
    ...rest
  } = props;

  return (
    <Button
      {...rest}
      type="button"
      size="lg"
      variant={active ? 'secondary' : variant}
      disabled={disabled}
      className={clsx(
        className,
        'py-3 pl-2 pr-4 min-w-28 text-sm font-medium transition-colors inline-flex shrink whitespace-normal'
      )}
      onClick={() => onClick?.(value)}
    >
      <span
        className={`mr-2 h-4 w-4 rounded-full border transition-colors flex-full-center shrink-0 border-accent  ${active ? 'bg-accent-foreground dark:bg-primary ' : 'dark:border-accent-foreground'}`}
      >
        {active && (
          <span className="block h-2 w-2 bg-secondary dark:bg-primary rounded-full m-auto shrink-0" />
        )}
      </span>
      <span className="break-words text-left">{children}</span>
    </Button>
  );
}
